module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/base/base.component.scss
// module id = ./src/app/base/base.component.scss
// module chunks = main